import React from 'react';
import cn from 'classnames';
import { useStatusBadgeIcon } from './hooks/useStatusBadgeIcon.js';

var defaultColors = {"positive-checkmark":"status-badge__positive-checkmark_3ejvs","negative-cross":"status-badge__negative-cross_3ejvs","negative-alert":"status-badge__negative-alert_3ejvs","negative-block":"status-badge__negative-block_3ejvs","attention-alert":"status-badge__attention-alert_3ejvs","neutral-information":"status-badge__neutral-information_3ejvs","neutral-operation":"status-badge__neutral-operation_3ejvs","neutral-cross":"status-badge__neutral-cross_3ejvs"};
require('./default.css')

var styles = {"component":"status-badge__component_1mve5","size-16":"status-badge__size-16_1mve5","size-20":"status-badge__size-20_1mve5","size-24":"status-badge__size-24_1mve5","size-32":"status-badge__size-32_1mve5","size-40":"status-badge__size-40_1mve5"};
require('./index.css')

var invertedColors = {"positive-checkmark":"status-badge__positive-checkmark_wc4t3","negative-cross":"status-badge__negative-cross_wc4t3","negative-alert":"status-badge__negative-alert_wc4t3","negative-block":"status-badge__negative-block_wc4t3","attention-alert":"status-badge__attention-alert_wc4t3","neutral-information":"status-badge__neutral-information_wc4t3","neutral-operation":"status-badge__neutral-operation_wc4t3","neutral-cross":"status-badge__neutral-cross_wc4t3"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var StatusBadge = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId, _b = _a.size, size = _b === void 0 ? 24 : _b, view = _a.view, _c = _a.colors, colors = _c === void 0 ? 'default' : _c, customIcons = _a.customIcons;
    var Icon = useStatusBadgeIcon(view, size, customIcons).Icon;
    return (React.createElement("div", { className: cn(styles.component, className, styles["size-".concat(size)], colorStyles[colors].component, colorStyles[colors][view]), "data-test-id": dataTestId },
        React.createElement(Icon, null)));
};

export { StatusBadge };
